/**
 * @module components/Maps/StationStatusControl
 * @author Charles Blais
 */

import React from 'react';
import PropTypes from 'prop-types';

import CustomControl from './CustomControl';

import { COLOR_OPEN, COLOR_CLOSE, COLOR_PLANNED } from '../../libs/display';

import { useLanguageState } from '../../contexts/LanguageProvider';


const StationStatusControl = ({
  position,
  showOpened,
  setShowOpened,
  showClosed,
  setShowClosed,
  showPlanned,
  setShowPlanned,
}) => {
  const [ lang ] = useLanguageState();

  return (
    <CustomControl className='leaflet-control-custom leaflet-control-layers' position={position}>
      { setShowOpened &&
        <label>
          <div style={{backgroundColor: COLOR_OPEN, padding: '5px'}}>
            <input
              type="checkbox"
              className="leaflet-control-layers-selector"
              checked={showOpened}
              onChange={() => setShowOpened(!showOpened)}
            /> <span>{lang.open}</span>
          </div>
        </label>
      }
      { setShowClosed &&
        <label>
          <div style={{backgroundColor: COLOR_CLOSE, padding: '5px'}}>
            <input
              type="checkbox"
              className="leaflet-control-layers-selector"
              checked={showClosed}
              onChange={() => setShowClosed(!showClosed)}
            /> <span>{lang.close}</span>
          </div>
        </label>
      }
      { setShowPlanned &&
        <label>
          <div style={{backgroundColor: COLOR_PLANNED, padding: '5px'}}>
            <input
              type="checkbox"
              className="leaflet-control-layers-selector"
              checked={showPlanned}
              onChange={() => setShowPlanned(!showPlanned)}
            /> <span>{lang.planned}</span>
          </div>
        </label>
      }
    </CustomControl>
  );
};


StationStatusControl.propTypes = {
  position: PropTypes.string,
  showOpened: PropTypes.bool,
  setShowOpened: PropTypes.func,
  showClosed: PropTypes.bool,
  setShowClosed: PropTypes.func,
  showPlanned: PropTypes.bool,
  setShowPlanned: PropTypes.func,
}


StationStatusControl.defaultProps = {
  position: 'bottomright',
  showOpened: false,
  setShowOpened: null,
  showClosed: false,
  setShowClosed: null,
  showUpcoming: false,
  setShowUpcoming: null,
}

export default StationStatusControl;